import { getEscapioDeals } from "@escapio/portal/state/escapio-deals";
import { data } from "@escapio/shared/state/payload";
import { load } from "@escapio/portal/components/ads/optimonk/loader";

const eDeals = getEscapioDeals();
const listHotelIds = data.hotel_list.map(({ id }) => id);
const listHasEscapioDeals = Object.keys(eDeals).some(hotelId =>
	listHotelIds.includes(+hotelId),
);

if (!listHasEscapioDeals) {
	load();
}
